var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-popin-modal2",
    {
      attrs: {
        id: _vm.id,
        "aria-labelledby": _vm.id,
        "show-close-button": false,
      },
    },
    [
      _c("h3", {
        staticClass: "my-1",
        domProps: { innerHTML: _vm._s(_vm.title) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-6", attrs: { id: "tdc-section" } },
          [
            _c(
              "div",
              [
                _c("h4", {
                  staticClass: "lead font-weight-bold mb-0",
                  domProps: { innerHTML: _vm._s(_vm.tdcSection.title) },
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "lead",
                  domProps: { innerHTML: _vm._s(_vm.tdcSection.description1) },
                }),
                _vm._v(" "),
                _c("ob1-message-complementaire", {
                  staticClass: "mb-1",
                  attrs: {
                    "is-reduced": "",
                    "has-alert-content": false,
                    title: _vm.tdcSection.ecoText,
                    icon: "icon-Eco-mode",
                  },
                }),
                _vm._v(" "),
                _c("advantage-bloc", {
                  attrs: {
                    "advantage-messages": _vm.advantageMessages,
                    "bonus-recovery": _vm.isOnlineRecoveryAvailable
                      ? _vm.bonusRecovery
                      : null,
                    discount: _vm.discount,
                    odr: _vm.odr,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("ob1-boutons", {
              staticClass: "mt-1 d-block mx-auto mx-md-0",
              attrs: {
                id: "online-button-id",
                "is-button": _vm.tdcSection.button.button,
                label: _vm.tdcSection.button.label,
                "is-secondary": true,
                "data-oevent-category": _vm.tdcSection.button.tmsDTO.tagZone,
                "data-oevent-action": _vm.tdcSection.button.tmsDTO.tagName,
                "data-oevent-label": _vm.tdcHref,
                href: _vm.tdcHref,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 d-md-none" }, [
          _c("hr", { staticClass: "separator separator--gray4 my-2" }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6", attrs: { id: "eresa-section" } },
          [
            _c(
              "div",
              [
                _c("h4", {
                  staticClass: "lead font-weight-bold mb-0",
                  domProps: { innerHTML: _vm._s(_vm.eresaSection.title) },
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "lead",
                  domProps: {
                    innerHTML: _vm._s(_vm.eresaSection.description1),
                  },
                }),
                _vm._v(" "),
                _c("ob1-message-complementaire", {
                  staticClass: "mb-1",
                  attrs: {
                    "is-reduced": "",
                    "has-alert-content": false,
                    title: _vm.eresaSection.ecoText,
                    icon: "icon-Eco-mode",
                  },
                }),
                _vm._v(" "),
                _c("advantage-bloc", {
                  attrs: {
                    "advantage-messages": _vm.advantageMessages,
                    "bonus-recovery": _vm.bonusRecovery,
                    discount: _vm.discount,
                    odr: _vm.odr,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("ob1-boutons", {
              staticClass: "mt-1 d-block mx-auto mx-md-0",
              attrs: {
                id: "eresa-button-id",
                "is-button": _vm.eresaSection.button.button,
                label: _vm.eresaSection.button.label,
                "is-secondary": true,
                "is-disabled": _vm.eresaSection.button.disabled,
                "data-oevent-category": _vm.eresaSection.button.tmsDTO.tagZone,
                "data-oevent-action": _vm.eresaSection.button.tmsDTO.tagName,
                "data-oevent-label": _vm.eresaHref,
                href: _vm.eresaHref,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 mt-2", attrs: { id: "ecoFootNote" } },
          [
            _c("p", {
              staticClass: "mb-0 small",
              domProps: { innerHTML: _vm._s(_vm.ecoFootNote) },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }